/* eslint-disable no-nested-ternary */
import React from "react";
import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

interface IHeaderTitleProps {
  isQuoteRequest: boolean;
  isNewShipment?: boolean;
  isMiniTender?: boolean;
  isEditShipment?: boolean;
  isOffPlatformShipment?: boolean;
}

function HeaderTitle({
  isQuoteRequest,
  isNewShipment,
  isMiniTender,
  isEditShipment,
  isOffPlatformShipment,
}: IHeaderTitleProps) {
  const { shipmentId } = useParams();

  if (isQuoteRequest && !isNewShipment) {
    return (
      <>
        {isMiniTender ? (
          <FormattedMessage id="new-request.form.newMiniTender" defaultMessage="New Mini Tender" />
        ) : !shipmentId ? (
          <FormattedMessage id="new-request.form.newQuoteRequest" defaultMessage="New Quote Request" />
        ) : isEditShipment ? (
          <span>
            <FormattedMessage id="new-request.form.editShipment" defaultMessage="Edit Shipment" />
            <span className="ml-3">{shipmentId}</span>
          </span>
        ) : (
          <span>
            <FormattedMessage id="new-request.form.editQuoteRequest" defaultMessage="Edit Quote Request" />
            <span className="ml-3">{shipmentId}</span>
          </span>
        )}
      </>
    );
  }

  if (isNewShipment) {
    return <FormattedMessage id="new-request.form.newShipment" defaultMessage="New shipment" />;
  }

  if (isOffPlatformShipment) {
    return <FormattedMessage id="general.tracker" defaultMessage="Tracker" />;
  }

  return (
    <>
      {!shipmentId ? (
        <FormattedMessage id="new-request.form.newQuickRequest" defaultMessage="New Quick Request" />
      ) : (
        <span>
          <FormattedMessage id="new-request.form.editQuickRequest" defaultMessage="Edit Quick Request" />
          <span className="ml-3">{shipmentId}</span>
        </span>
      )}
    </>
  );
}

export default HeaderTitle;
